import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const OrganizationalInfoSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  isCollapsed, 
  onToggleCollapse,
  districts,
  samithis,
  roles
}) => {
  const customFilter = (option, inputValue) => {
    return option.keyValue.toLowerCase().includes(inputValue.toLowerCase());
  }
  return (
    <div className="bg-card border border-border rounded-lg shadow-spiritual-sm mb-6">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="Building" size={20} className="text-warning" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground">
              Organizational Information
            </h3>
            <p className="text-sm text-muted-foreground">
              Sai organization details and membership information
            </p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-muted-foreground" 
        />
      </div>

      {!isCollapsed && (
        <div className="p-6 pt-6 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Select
              label="Samithi"
              placeholder="Select samithi"
              options={samithis}
              value={formData.samithi}
              onChange={(value) => handleInputChange('samithi', value)}
              error={errors.samithi}
              filterOption={customFilter}
              required
              searchable
              // disabled={!formData.district}
            />

            <Select
              label="Role"
              placeholder="Select role"
              options={roles}
              value={formData.role}
              onChange={(value) => handleInputChange('role', value)}
              error={errors.role}
            />

            <Input
              label="Sai Connect ID"
              type="text"
              placeholder="Enter Sai Connect ID"
              value={formData.saiOneId}
              onChange={(e) => handleInputChange('saiOneId', e.target.value)}
              error={errors.saiOneId}
              required
            />

            <Input
              label="PMC Number"
              type="text"
              placeholder="Enter PMC number"
              value={formData.pmcNo}
              onChange={(e) => handleInputChange('pmcNo', e.target.value)}
              error={errors.pmcNo}
            />

            <Input
              label="Sevadal Certificate Number"
              type="text"
              placeholder="Enter certificate number"
              value={formData.scNo}
              onChange={(e) => handleInputChange('scNo', e.target.value)}
              error={errors.scNo}
            />

            <div className={`p-4 rounded-lg border flex flex-col justify-center transition-colors ${
              formData.is_blocked
                ? 'bg-red-50/70 border-red-300 dark:bg-red-950/20 dark:border-red-800'
                : 'bg-muted/20 border-border'
            }`}>
              <div className="flex items-center justify-between">
                <div>
                  <label
                    htmlFor="is_blocked"
                    className={`text-sm font-semibold cursor-pointer flex items-center gap-2 ${
                      formData.is_blocked ? 'text-red-700 dark:text-red-400' : 'text-foreground'
                    }`}
                  >
                    {formData.is_blocked && (
                      <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse"></span>
                    )}
                    Block Member
                  </label>
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {formData.is_blocked
                      ? 'Member is marked as blocked and cannot be enrolled for service'
                      : 'Unchecked: Member is active and eligible for service'}
                  </p>
                </div>
                <input
                  type="checkbox"
                  id="is_blocked"
                  name="is_blocked"
                  checked={Boolean(formData.is_blocked)}
                  onChange={(e) => handleInputChange('is_blocked', e.target.checked)}
                  className="h-5 w-5 rounded border-gray-300 text-red-600 focus:ring-red-500 cursor-pointer accent-red-600"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationalInfoSection;